import { LeaseCarDataResponse } from 'types';

export const SET_LEASE_CAR_DATA = 'SET_LEASE_CAR_DATA';
export const RESET_LEASE_CAR_DATA = 'RESET_LEASE_CAR_DATA';

export type SetLeaseCarData = {
	type: typeof SET_LEASE_CAR_DATA;
	payload: LeaseCarDataResponse;
};

export type ResetCarDataResponseAction = {
	type: typeof RESET_LEASE_CAR_DATA;
};

export type LeaseCarDataActionTypes = SetLeaseCarData | ResetCarDataResponseAction;
